module.exports = __webpack_public_path__ + "img/saved-blue.1b39bb19.svg";